import { EventBus } from "@/main.js"
export default {

  methods: {
    setLoading(val) {
      EventBus.$emit("set-is-loading", val)
    },
    setMode(val) {
      EventBus.$emit("change-mode", val)
    },
    setModeConfirmation() {
      this.setMode("confirmation")
    },
    setModeErreur() {
      this.setMode("erreur")
    },
    setModeDefault() {
      this.setMode("default")
    },
    setModeForm() {
      this.setMode("form")
    }
  }
}